import React, { useEffect, useState } from "react";
import { DialogBox } from "../../shared/components/dialog";
import { DialogContent, Stack, TextField } from "@mui/material";
import { useArcAuth } from "@arcauth/react-sdk";
import { useDispatch, useSelector } from "react-redux";
import { getUserInfo, updateUserInfo } from "../../redux/features/user.slice";
import { RootStateType } from "../../redux/features/rootSlice";
import { MESSAGES, webSocketMessage } from "../../config/app";
import useWebSocket from "../../hooks/useWebSocket";
import { nameRegex } from "../../shared/util/authentication.regex";
export interface DialogProps {
  open: boolean;
  onClose: () => void;
  user?: {
    id: string;
    firstname: string;
    lastname: string;
    phone: string;
    email: string;
    newpassword: string;
    oldpassword: string;
    language: string;
    timezone: string;
  };
}

interface fullName {
  firstname: string;
  lastname: string;
}
const NameUpdate = (props: DialogProps) => {
  const { open, onClose, user } = props;
  const dispatch = useDispatch();
  const { updateUserAndNotifyParent } = useWebSocket();
  const [name, setName] = useState<fullName>({ firstname: "", lastname: "" });
  const [buttonEnabled,setButtonEnabled] = useState(false);

  const nameUpdate_loading = useSelector(
    (state: RootStateType) => state.userStateReducer.loading
  );

  const dialogClose = () => {
    onClose();
  };

  const handleListItemClick = async () => {
    const dispatchObj = {
      user: {
        firstname: name?.firstname?.trim(),
        lastname: name?.lastname?.trim(),
      },
      successMessage: MESSAGES.nameSuccess,
      callBackSuccess: () => {
        updateUserAndNotifyParent(webSocketMessage.nameResponse);
        onClose();
        dispatch(getUserInfo());
        setButtonEnabled(false);
      },
    };
    dispatch(updateUserInfo(dispatchObj));
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && buttonEnabled) {
      e.preventDefault();
      handleListItemClick();
    }
  };
  useEffect(() => {
    setName({
      firstname: user?.firstname ?? "",
      lastname: user?.lastname ?? "",
    });
  }, [user]);

  useEffect(() => {
    if ((name.firstname == "") && (name.lastname == ""))
      setButtonEnabled(false);
    else {
      if ((nameRegex.test(name?.firstname)) && ((name?.firstname != user?.firstname) || (name?.lastname != user?.lastname)))
        {
          setButtonEnabled(true);
        }
        else
        setButtonEnabled(false);
      }
  }, [name]);

  return (
    <>
      <DialogBox
        onClose={dialogClose}
        title={"Update name"}
        buttonText={"Update"}
        buttonClick={handleListItemClick}
        isLoading={nameUpdate_loading}
        isBtnEnabled={!buttonEnabled}
        open={open}
        style={{ maxWidth: 500, mx: "auto" }}
      >
        <DialogContent>
          <Stack>
            <label htmlFor="" style={{fontSize: 13}}>First name</label>
            <TextField
              size="small"
              fullWidth
              sx={{mb: 2}}
              // label="First name"
              value={name?.firstname ?? ""}
              placeholder="Enter first name"
              color="secondary"
              inputProps={{ maxLength: 30 }}
              onKeyDown={handleKeyDown}
              onChange={(e) => {
                const trimmedValue = e.target.value.replace(/^\s+/, ""); // Trim leading spaces only
                setName({ ...name, firstname: trimmedValue }); // Preserve lastname
              }}
            />
            <label htmlFor="" style={{fontSize: 13}}>Last name</label>
            <TextField
              size="small"
              fullWidth
              // label="Last name"
              value={name?.lastname ?? ""}
              placeholder="Enter last name"
              color="secondary"
              inputProps={{ maxLength: 30 }}
              onKeyDown={handleKeyDown}
              onChange={(e) => {
                const trimmedValue = e.target.value.replace(/^\s+/, ""); // Trim leading spaces only
                setName({ ...name, lastname: trimmedValue }); // Preserve lastname
              }}
            />
          </Stack>
        </DialogContent>
      </DialogBox>
    </>
  );
};

export default NameUpdate;
